import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const JOB_BASE = process.env.REACT_APP_JOB_CREATE_BASE || "";

export const getCompanyDetail = createAsyncThunk(
  "getCompanyDetail",
  async (firmName: string) => {
    try {
      const { data } = await axios.get(
        `${GATEWAY_BASE + JOB_BASE}/api/v1/firm/details?firm=${firmName}`
      );

      return data;
    } catch (error: any) {
      // Throw the entire error object to be caught in the rejected case
      throw error.response?.data.statusCode;
    }
  }
);

const getCompanyDetailSlice = createSlice({
  name: "getCompanyDetail",
  initialState: {
    loading: false,
    companyDetails: null as any,
    error: false,
    errorData: null as any,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCompanyDetail.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCompanyDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.companyDetails = action.payload;
    });
    builder.addCase(getCompanyDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorData = action.error;
    });
  },
});

export default getCompanyDetailSlice.reducer;
